import React, {Component} from "react";

export class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (

                <div className="ui inverted horizontal footer segment" id={"footer-container"}>
                    <div className="ui container">
                        {/*<div className="ui stackable inverted divided equal height stackable grid">*/}
                        {/*    <div className="three wide column">*/}
                        {/*        <h4 className="ui inverted header">About</h4>*/}
                        {/*        <h4 className="ui inverted header">Contact Us</h4>*/}
                        {/*        <h4 className="ui inverted header">Privacy</h4>*/}
                        {/*        <h4 className="ui inverted header">Help</h4>*/}
                        {/*        <h4 className="ui inverted header">Road Map</h4>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={"ui horizontal list"}>
                            <div className="item">
                                    <div className="content">
                                        <a className="header" href={"/privacy"}>Privacy</a>
                                    </div>
                            </div>
                            <div className="item">
                                    <div className="content">
                                        <a className="header" href={"/terms"}>Terms of Use</a>
                                    </div>
                            </div>
                            <div className="item">
                                    <div className="content">
                                        <a className="header" href={"/disclaimer"}>Disclaimer</a>
                                    </div>
                            </div>
                            <div className="item">
                                <div className="content">
                                    <a className="header" href={"/security"}>Security</a>
                                </div>
                            </div>
                            <div className={"item"}>
                                <div className={"content"}>
                                    <a className={"header"} href={"/personal-message"}> Gratitude </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )

    }
}